(function($) {
    
    jQuery(document).ready(function() {

        // Sticky head

        if ( royaleNewsProJsData.isHeaderSticky === '1' ) {
            $(".sticky-header").sticky({ topSpacing: 0 });
        }
        
        // Main navigation

        $('.main-navigation').meanmenu({
            meanMenuContainer: '.menu-container',
            meanScreenWidth: "768",
            meanRevealPosition: "right",
        });


        // Sticky sidebar
        if ( royaleNewsProJsData.isSidebarSticky === '1' ) {
            jQuery('.sticky-section').theiaStickySidebar({
                additionalMarginTop: 0
            });
        }


        // Scroll to top

        $('#scroll-top').on( 'click', function() {
            $('html, body').animate({ scrollTop: 0 }, 600);
            return false;
        });


        // Search icon 

        $('.search-icon').on( 'click', function() {
            $('.search-form-container').fadeToggle();
        });


        // News ticker

        $('.ticker-news-carousel').owlCarousel({
            items: 1,
            animateOut: 'fadeOutUp',
            animateIn: 'fadeInUp',
            autoplay: true,
            loop: true,
            nav: false,
            dots: false,
        });

        // ticker news for header bottom 
        
        $('.ticker-news-carousel').owlCarousel({
            
            items: 1,
            animateOut: 'fadeOutUp',
            animateIn: 'fadeInUp',
            autoplay: true,
            loop: true,
            nav: true,
            dots: false,
        });



        // News carousel

        $('.highlight-carousel').owlCarousel({
            items: 2,
            animateIn: 'fadeIn',
            autoplay: true,
            loop: true,
            dots: false,
            responsive: {
                0: {
                    items: 1
                },
                767: {
                    items: 2
                },
                991: {
                    items: 2
                },
                1199: {
                    items: 3
                }
            }
        });


        // News carousel

        $('.highlight-left-carousel').owlCarousel({
            items: 1,
            autoplay: true,
            loop: true,
            nav: true,
        });


        // News carousel


        $('.small-slider-highlight').owlCarousel({
            items: 3,
            animateIn: 'fadeIn',
            autoplay: true,
            loop: true,
            margin: 10,
            nav: false,
            dots: false,
            responsive: {
                0: {
                    items: 1
                },
                767: {
                    items: 2
                },
                991: {
                    items: 3
                },
                1199: {
                    items: 3
                }
            }
        });


        // Related post carousel

        $('.related-slider').owlCarousel({
            items: 3,
            animateIn: 'fadeIn',
            autoplay: true,
            loop: true,
            margin: 10,
            nav: false,
            dots: false,
            responsive: {
                0: {
                    items: 1
                },
                767: {
                    items: 2
                },
                991: {
                    items: 2
                },
                1199: {
                    items: 2
                }
            }
        });


        // News carousel


        $('.news-section-carousel').owlCarousel({
            items: 2,
            animateIn: 'fadeIn',
            autoplay: true,
            loop: false,
            nav: true,
            dots: false,
            rewind: true,
            margin: 5,
            responsive: {
                0: {
                    items: 1
                },
                767: {
                    items: 2
                },
                991: {
                    items: 2
                },
                1199: {
                    items: 2
                }
            }
        });


        // News carousel


        $('.sidebar-widget-carousel').owlCarousel({
            items: 1,
            autoplay: true,
            loop: true,
            nav: false,
            dots: false,
            rewind: true,
            margin: 5,
            responsive: {
                0: {
                    items: 1
                },
                767: {
                    items: 1
                },
                991: {
                    items: 1
                },
                1199: {
                    items: 1
                }
            }
        });
    });


	// Scroll to top

    $(window).on( 'scroll', function() {
        if ($(this).scrollTop() > 100) {
            $('.scroll-top').fadeIn(600);
        } else {
            $('.scroll-top').fadeOut(600);
        }
    });


})(jQuery);